import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DatePipe, DecimalPipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { EmailReservationService } from '../../core/services/email-reservation.service';
import { UserService } from '../../core/services/user.service';
import { PagerComponent } from '../../shared/components/pager.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

@Component({
    selector: 'app-email-reservation-list',
    imports: [RouterLink, FormsModule, DatePipe, DecimalPipe, PagerComponent, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ filteredItems.length }} 件)</span></span>
    </div>
    <div class="card-body">
      <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
      <form novalidate>
        <div class="row" style="align-items: flex-end;">
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">店舗</label>
                <select class="form-control" [(ngModel)]="studioFilter" name="studioFilter" (ngModelChange)="pageIndex=0">
                  <option [ngValue]="null">-- すべて --</option>
                  @for (s of studios; track s.id) {
                    <option [ngValue]="s.id">{{ s.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">状態</label>
                <select class="form-control" [(ngModel)]="statusFilter" name="statusFilter" (ngModelChange)="pageIndex=0">
                  <option [ngValue]="null">-- すべて --</option>
                  @for (so of statusOptions; track so.id) {
                    <option [ngValue]="so.id">{{ so.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row align-items-end">
              <div class="form-group col-md-8">
                <label class="col-form-label">キーワード検索</label>
                <input type="text" class="form-control" [(ngModel)]="keyword" name="keyword" placeholder="件名など" (ngModelChange)="pageIndex=0">
              </div>
              <div class="form-group col-md-4">
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                      <i class="fa s-icon-backspace"></i>&nbsp;条件クリア
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <div class="col-md-12">
          <a class="btn btn-primary text-white" routerLink="/email/reservation/new">
            <i class="fa s-icon-plus"></i>&nbsp;新規作成
          </a>
        </div>
      </div>
      @if (searching) {
        <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
      }
      @if (!searching && filteredItems.length === 0) {
        <span>該当するデータはありません</span>
      }
      @if (filteredItems.length > 0) {
        <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
        <table class="table table-bordered table-sm table-hover table-ptb-0">
          <thead>
            <tr>
              <th width="10%">状態</th>
              <th>件名</th>
              <th>作成者(From)</th>
              <th width="30%">配信条件(To)</th>
              <th>配信日時</th>
              <th width="10%">配信人数</th>
              <th>作成日時</th>
            </tr>
          </thead>
          <tbody>
            @for (item of pagedItems; track item.id) {
              <tr>
                <td class="text-center">
                  @if (item.status == 0) {
                    <button class="btn text-warning p-0 bg-inherit active" type="button" title="予約中" (click)="openDeleteModal(item)">
                      <span class="material-icons-outlined large-size">schedule_send</span>
                    </button>
                  }
                  @if (item.status == 1) {
                    <button class="btn text-primary bg-inherit p-0 active" type="button" title="配信中">
                      <span class="material-icons-outlined large-size">forward</span>
                    </button>
                  }
                  @if (item.status == 2) {
                    <button class="btn text-green bg-inherit p-0 active" type="button" title="配信済">
                      <i class="fa fa-2x s-icon-finished"></i>
                    </button>
                  }
                  @if (item.status == 3) {
                    <button class="btn text-secondary bg-inherit p-0 active" type="button" title="削除済み">
                      <i class="fa fa-2x s-icon-close"></i>
                    </button>
                  }
                </td>
                <td>{{ item.subject ?? item.emailContent?.subject }}</td>
                <td>{{ item.user?.name }}:<br>{{ item.user?.email }}</td>
                <td class="td-scroll">
                  <div>
                    @if (item.conditionMemberStatus) {
                      <span>会員状態[{{ item.studioName }}]: {{ item.conditionMemberStatus }}<br></span>
                    }
                    @if (item.conditionStudioPlan) {
                      <span>会員区分コース[{{ item.studioName }}]: {{ item.conditionStudioPlan }}<br></span>
                    }
                    @if (item.conditionStudio) {
                      <span>ユーザー店舗: {{ item.conditionStudio }}<br></span>
                    }
                    @if (item.conditionUser) {
                      <span>ユーザー: {{ item.conditionUser }}<br></span>
                    }
                    @if (item.conditionUserRole) {
                      <span>ユーザー権限: {{ item.conditionUserRole }}</span>
                    }
                  </div>
                </td>
                <td>{{ item.deliveryAt | date:'yyyy/MM/dd HH:mm' }}</td>
                <td class="text-right">{{ item.targetCount | number }}人</td>
                <td>{{ item.createdAt | date:'yyyy/MM/dd HH:mm' }}</td>
              </tr>
            }
          </tbody>
        </table>
        <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
      }
    </div>
  </div>
</div>

@if (showDeleteModal && selectedItem) {
  <div class="modal-backdrop fade show" (click)="showDeleteModal = false"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content border-danger">
        <div class="modal-header bg-danger">
          <h5 class="modal-title">配信予約の削除</h5>
          <button type="button" class="close" (click)="showDeleteModal = false">
            <span class="text-white">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="background-color: #FFF6F8 !important">
          <div class="form-group row">
            <label class="col-md-12 col-form-label">配信予約を削除します。よろしいですか。</label>
          </div>
        </div>
        <div class="modal-footer" style="background-color: #FFF6F8 !important">
          <button class="btn bg-close text-white" type="button" (click)="showDeleteModal = false">
            <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-danger" type="button" (click)="doDelete()">
            <i class="fa s-icon-delete"></i>&nbsp;削除
          </button>
        </div>
      </div>
    </div>
  </div>
}
  `
})
export class EmailReservationListComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private emailReservationService = inject(EmailReservationService);
  private userService = inject(UserService);
  private flash = inject(FlashService);

  items: any[] = [];
  studios: any[] = [];
  keyword = '';
  studioFilter: number | null = null;
  statusFilter: number | null = null;
  searching = true;
  readonly pageLimit = 100;
  pageIndex = 0;
  showDeleteModal = false;
  selectedItem: any = null;
  statusOptions = [
    { id: 0, name: '予約中' },
    { id: 1, name: '配信中' },
    { id: 2, name: '配信済' },
  ];

  get filteredItems(): any[] {
    return this.items.filter(i => {
      if (this.studioFilter !== null && i.studioId !== this.studioFilter) return false;
      if (this.statusFilter !== null && i.status !== this.statusFilter) return false;
      if (!matchesNestedKeyword(i, this.keyword)) return false;
      return true;
    });
  }

  get pagedItems(): any[] {
    return this.filteredItems.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }
  get totalPages(): number {
    return Math.ceil(this.filteredItems.length / this.pageLimit);
  }
  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  clearFilter(): void {
    this.pageIndex = 0;
    this.keyword = '';
    this.statusFilter = null;
  }

  openDeleteModal(item: any): void {
    this.selectedItem = item;
    this.showDeleteModal = true;
  }

  async doDelete(): Promise<void> {
    if (!this.selectedItem?.id) return;
    this.showDeleteModal = false;
    const result: any = await this.emailReservationService.updateStatus({ id: this.selectedItem.id, status: 3 });
    // 旧版 email-reservation.js:85-97: 更新0件はdanger、それ以外success（5.5秒）、先頭へscroll
    window.scrollTo(0, 0);
    if (result?.error || (Array.isArray(result) && result[0] === 0)) {
      this.flash.create('danger', '予約中以外の配信予約は削除できません。', 5500);
      return;
    }
    this.flash.create('success', '配信予約を削除しました。', 5500);
    this.selectedItem.status = 3;
    this.selectedItem = null;
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('配信予約', 'schedule_send', true);
    try {
      [this.items, this.studios] = await Promise.all([
        this.emailReservationService.get() ?? [],
        // 旧版 email-reservation.js:70 と同じく自分の担当店舗だけを候補にする
        this.userService.getStudio('own') ?? [],
      ]) as [any[], any[]];
      this.items = this.items ?? [];
      this.studios = this.studios ?? [];
    } finally {
      this.searching = false;
    }
  }
}
